import { useRoleConditional } from 'components';
import { not } from 'ramda';
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import logo from '../../assets/img/logo-white.svg';
// TODO: Modify this imports to use index.js
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import routes from './routes';
import { ErrorBoundary } from '#components';
import { useDashboardStyles } from './styles';

const useProperRoutes = () => {
  const { includes, notIncludes } = useRoleConditional();

  const properRoutes = useMemo(
    () => routes.filter(({ allowedRoles, deniedRoles }) => {
      if (deniedRoles) {
        return notIncludes(deniedRoles);
      }

      if (allowedRoles) {
        return includes(allowedRoles);
      }

      return true;
    }),
    [includes, notIncludes]
  );

  return properRoutes;
};

const Dashboard = () => {
  const properRoutes = useProperRoutes();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const classes = useDashboardStyles();
  const toggleSidebar = useCallback(() => setSidebarOpen(not), [setSidebarOpen]);

  const routesComponent = properRoutes.map(
    route => (route.redirect ? (
      <Redirect key={`redirect-${route.path}`} to={route.path} />
    ) : (
      <Route key={route.path} path={route.path} component={route.component} />
    ))
  );

  function resizeFunction(e) {
    if (e.matches && sidebarOpen) {
      toggleSidebar();
    }
  }

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 980px)');
    mq.addEventListener('change', resizeFunction);

    return () => {
      mq.removeEventListener('change', resizeFunction);
    };
  });

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={properRoutes}
        logoText="Bob"
        logo={logo}
        handleDrawerToggle={toggleSidebar}
        open={sidebarOpen}
      />
      <div className={classes.mainPanel}>
        <Header handleDrawerToggle={toggleSidebar} routes={properRoutes} />
        <div className={classes.content}>
          <ErrorBoundary>
            <Switch>{routesComponent}</Switch>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
